import React from "react";
import { Sparkline } from "./Sparkline";
import { formatNum, formatPercent, signColor } from "../lib/format";

export const IndexTile = ({ idx }) => {
  const up = idx.change_percent >= 0;
  return (
    <div
      data-testid={`index-card-${idx.id}`}
      className="lv-panel lv-panel-hover group flex flex-col justify-between p-3.5 transition-transform duration-200 hover:-translate-y-0.5"
    >
      <div className="flex items-start justify-between gap-2">
        <div>
          <div className="font-mono text-[11px] font-semibold uppercase tracking-wider text-zinc-300">{idx.name}</div>
          <div className="mt-0.5 font-mono text-[9px] uppercase tracking-widest text-zinc-600">{idx.category}</div>
        </div>
        <span className="h-1.5 w-1.5 rounded-full" style={{ background: idx.color }} />
      </div>
      <div className="mt-3 font-mono text-xl font-bold text-white tabular-nums">{formatNum(idx.value)}</div>
      <div className={`mt-0.5 font-mono text-xs ${signColor(idx.change_percent)}`}>
        {up ? "+" : ""}{formatNum(idx.change)} ({formatPercent(idx.change_percent)})
      </div>
      <div className="mt-2 h-8 opacity-85 transition-opacity group-hover:opacity-100">
        <Sparkline data={idx.sparkline} color={up ? "#10B981" : "#F43F5E"} height={32} />
      </div>
    </div>
  );
};
